import { render, staticRenderFns } from "./UsergroupConficGroups.vue?vue&type=template&id=3ba8ee43"
import script from "./UsergroupConficGroups.vue?vue&type=script&lang=js"
export * from "./UsergroupConficGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports